import { useState } from "react";
import { useSelector } from "react-redux";
import ICONS from "../../../assets/Icons";
import NotificationPopup from "../NotificationPopup";
import SVGComponent from "../../_utils/SVGComponent";
import { GlobalConfiguration } from "../../../utils/configurationProvider";

const NotificationBell = () => {
  const [isOpen, setIsOpen] = useState(false);
  const unreadCount = Number(
    useSelector((state) => state?.notificationsSlice?.notificationsData?.summary?.unread) ||
      GlobalConfiguration.lengthCheckZero,
  );

  return (
    <>
      <button
        type="button"
        aria-label="Open notifications"
        className="flex items-center justify-center"
        onClick={(event) => {
          event.stopPropagation();
          setIsOpen(true);
        }}
      >
        <SVGComponent
          url={
            unreadCount > GlobalConfiguration.lengthCheckZero
              ? ICONS?.NOTIFICATION_WITH_INDICATOR
              : ICONS?.NOTIFICATION_WITH_NO_INDICATOR
          }
          width="var(--icon-md)"
          height="var(--icon-md)"
        />
      </button>
      {isOpen && (
        <div className="fixed top-top-base left-left-base w-screen h-screen bg-PopUp-BackDrop bg-opacity-dark-opacity z-z-index-modal">
          <NotificationPopup onClose={() => setIsOpen(false)} />
        </div>
      )}
    </>
  );
};

export default NotificationBell;
